import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import * as Auth from '@aws-amplify/auth'
import { Amplify } from 'aws-amplify'

import amplifyConfig from '../amplify.config'

// Amplify-Konfiguration initialisieren
Amplify.configure(amplifyConfig)

export const loginGuard: CanActivateFn = async () => {
  const router = inject(Router)
  try {
    const user = await Auth.getCurrentUser()
    if (user) {
      router.navigate(['/'])
      return false
    }
    return true
  } catch (error) {
    const err = error as Error
    console.error(err.name)
    if (err.name === 'UserUnAuthenticatedException') {
      return true
    }
  }
  return false
}
